const EC_SUPPORTED_LANGUAGES = ['en', 'es', 'ja', 'ko', 'pt', 'ru', 'tr', 'vi', 'zh', 'he', 'ar', 'fr'];

export function getECLanguageToUse(lang: string) {
  if (EC_SUPPORTED_LANGUAGES.findIndex((l) => l === lang) < 0) {
    return 'en';
  }

  return lang;
}



// WEBPACK FOOTER //
// ./ts/app/shared/ec-modal/ec-supported-languages.ts